



































































import { BulkDistrItem, BulkDistrItemImpl } from "@/store/user_management/distr_moderation/types";
import { Vue, Component } from "vue-property-decorator";
import { Action } from "vuex-class";
import {getTranslatedParams} from "@/utils/notify-utils";
import {ActionLog} from "@/store/auth/types";

@Component({})
export default class SmsDistribution extends Vue {
  @Action("getBulkDistrItem") actionGetDistributionItem: any;
  @Action("actionLog") actionLog: any;

  private distribution = new BulkDistrItemImpl();
  // private distributionSaved = this.defaultDistribution();
  private logObject: ActionLog = {};

 async created() {
    if (this.$route.params.id) {
      try {
        this.logObject = {
          action_page: this.$route.meta.msgKey,
          action: "Viewing",
          action_status: "success",
          object_type: "Distribution",
          addititional_info: getTranslatedParams({channel: this.$route.params.channel, id: this.$route.params.id})
        }
        await this.actionGetDistributionItem(this.$route.params.id).then((data: BulkDistrItem) => {
          this.distribution = Object.assign({}, this.distribution, data);
          // this.distributionSaved = cloneDeep(Object.assign({}, this.distribution, data));
        });
        await this.actionLog(this.logObject);
      } catch (err){
        await this.actionLog({...this.logObject, action_status: "failed"});
      }
    }
  }
}
